import React from 'react';
import './Stories.module.scss';
import { useSelector } from 'react-redux';
import Video from 'components/UI/Card/components/Video';

export default function Stories(props) {
    const page = useSelector((state) => {
        const pages = state.page.entities.allIds.map(
            (pageId) => state.page.entities.byId[pageId]
        );
        return pages.find((p) => p.slug === 'verhalen');
    });

    const videos = page?.content.find((e) => e.layout === 'video_gallery')
        ?.attributes?.content;
    const shortenedVideos = videos?.slice(0, 3);

    return (
        <div styleName="stories">
            {shortenedVideos &&
                shortenedVideos.map((video, i) => (
                    <div key={i} styleName="video">
                        <Video
                            videoType={video?.attributes?.video_type}
                            video={video?.attributes.video_id}
                            styleName="video"
                        />
                    </div>
                ))}
        </div>
    );
}
